"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetScolapassInvoices = void 0;
class GetScolapassInvoices {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    execute(request, callback) {
        return this.userRepository.getScolapassInvoices(request, callback);
    }
}
exports.GetScolapassInvoices = GetScolapassInvoices;
